(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Delivery_statusDetailController', Delivery_statusDetailController);

    Delivery_statusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Delivery_status'];

    function Delivery_statusDetailController($scope, $rootScope, $stateParams, previousState, entity, Delivery_status) {
        var vm = this;

        vm.delivery_status = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('doctorclubboApp:delivery_statusUpdate', function(event, result) {
            vm.delivery_status = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
